module.exports = __webpack_public_path__ + "img/ic_game_fuliguan.05f770af.png";